module.exports = __webpack_public_path__ + "img/asset-02.c501d140.svg";